import type { RouteRecordRaw } from "vue-router";
import EditHousePage from "./EditHousePage.vue";
import HouseCanvassesPage from "./HouseCanvassesPage.vue";
import HouseCommentsPage from "./HouseCommentsPage.vue";
import HouseContactsPage from "./HouseContactsPage.vue";
import HouseConversationsPage from "./HouseConversationsPage.vue";
import HouseLayout from "./HouseLayout.vue";
import HousesPage from "./HousesPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/houses",
    children: [
      { path: "", name: "houses", component: HousesPage },
      {
        path: "/houses/:houseId",
        name: "House",
        component: HouseLayout,
        props: (route) => ({
          houseId: parseInt(route.params.houseId as string, 10),
        }),
        children: [
          {
            path: "",
            name: "editHouse",
            component: EditHousePage,
          },
          {
            path: "contacts",
            name: "houseContacts",
            component: HouseContactsPage,
          },
          {
            path: "conversations",
            name: "houseConversations",
            component: HouseConversationsPage,
          },
          {
            path: "comments",
            name: "houseComments",
            component: HouseCommentsPage,
          },
          {
            path: "canvasses",
            name: "houseCanvasses",
            component: HouseCanvassesPage,
          },
        ],
      },
    ],
  },
];

export default routes;
